var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFoldedPaperTeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2115 7.42188C10.8839 7.42188 9.80762 8.49811 9.80762 9.82572V31.9411C9.80762 33.2687 10.8839 34.345 12.2115 34.345H28.5576C29.8852 34.345 30.9615 33.2687 30.9615 31.9411V21.845C30.9615 19.1897 28.809 17.0373 26.1538 17.0373H23.7499C22.4223 17.0373 21.3461 15.961 21.3461 14.6334V12.2296C21.3461 9.57435 19.1936 7.42188 16.5384 7.42188H12.2115ZM14.6153 24.7296C14.6153 24.1985 15.0458 23.768 15.5768 23.768H25.1922C25.7233 23.768 26.1538 24.1985 26.1538 24.7296C26.1538 25.2606 25.7233 25.6911 25.1922 25.6911H15.5768C15.0458 25.6911 14.6153 25.2606 14.6153 24.7296ZM15.5768 27.6142C15.0458 27.6142 14.6153 28.0447 14.6153 28.5757C14.6153 29.1068 15.0458 29.5373 15.5768 29.5373H20.3845C20.9156 29.5373 21.3461 29.1068 21.3461 28.5757C21.3461 28.0447 20.9156 27.6142 20.3845 27.6142H15.5768Z",
    fill: "#06799B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6297 7.82688C22.6512 9.0071 23.2692 10.5462 23.2692 12.2296V14.6334C23.2692 14.8989 23.4844 15.1142 23.7499 15.1142H26.1538C27.8372 15.1142 29.3762 15.7322 30.5565 16.7537C29.4182 12.3961 25.9873 8.96518 21.6297 7.82688Z",
    fill: "#06799B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoldedPaperTeal);
export default __webpack_public_path__ + "static/media/Icon_FoldedPaper_Teal.3a1efb8537ae3e727662a216192d6458.svg";
export { ForwardRef as ReactComponent };